import React from 'react'
import styled, { css } from 'styled-components'
import { Block, Text } from '@mote/ui'

const feedbackEmojis = [
  {
    name: 'Hate',
    svg: (
      <svg
        width='40'
        height='41'
        viewBox='0 0 40 41'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <circle cx='20' cy='20.647' r='20' fill='#F44336' />
        <circle cx='13.5005' cy='14.5781' r='1.5' fill='black' />
        <circle cx='25.5' cy='14.5781' r='1.5' fill='black' />
        <path
          d='M7.99951 30.0762C7.99951 30.0762 11.4995 21.0762 19.9995 21.0762C28.4995 21.0762 31.9995 30.0762 31.9995 30.0762'
          stroke='black'
          strokeWidth='0.884273'
        />
      </svg>
    ),
    rating: 1
  },
  {
    name: 'Dislike',
    svg: (
      <svg
        width='40'
        height='41'
        viewBox='0 0 40 41'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <circle cx='20' cy='20.897' r='20' fill='#FEB43B' />
        <circle cx='13.5' cy='14.8276' r='1.5' fill='black' />
        <circle cx='25.5' cy='14.8276' r='1.5' fill='black' />
        <path
          d='M8 27.3281C8 27.3281 11.5 22.3281 20 22.3281C28.5 22.3281 32 27.3281 32 27.3281'
          stroke='black'
          strokeWidth='0.938794'
        />
      </svg>
    ),
    rating: 2
  },
  {
    name: 'Neutral',
    svg: (
      <svg
        width='40'
        height='41'
        viewBox='0 0 40 41'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <circle cx='20' cy='20.147' r='20' fill='#FEEB3B' />
        <circle cx='13.5002' cy='14.0767' r='1.5' fill='black' />
        <circle cx='25.5' cy='14.0767' r='1.5' fill='black' />
        <path
          d='M7.99976 24.5786H31.9998'
          stroke='black'
          strokeWidth='0.913794'
        />
      </svg>
    ),
    rating: 3
  },
  {
    name: 'Like',
    svg: (
      <svg
        width='40'
        height='41'
        viewBox='0 0 40 41'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <circle cx='20' cy='20.2847' r='20' fill='#57C96A' />
        <path
          d='M8 21.7144C8 21.7144 11.5 26.7144 20 26.7144C28.5 26.7144 32 21.7144 32 21.7144'
          stroke='black'
          strokeWidth='0.9'
        />
        <circle cx='14.5' cy='14.2153' r='1.5' fill='black' />
        <circle cx='26.5' cy='14.2153' r='1.5' fill='black' />
      </svg>
    ),
    rating: 4
  },
  {
    name: 'Love',
    svg: (
      <svg
        width='40'
        height='41'
        viewBox='0 0 40 41'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <circle cx='20' cy='20.2847' r='20' fill='#51A25F' />
        <path
          d='M8 21.7153C8 21.7153 11.5 30.7153 20 30.7153C28.5 30.7153 32 21.7153 32 21.7153'
          stroke='black'
          strokeWidth='0.9'
        />
        <circle cx='14.5' cy='14.2153' r='1.5' fill='black' />
        <circle cx='26.5' cy='14.2153' r='1.5' fill='black' />
      </svg>
    ),
    rating: 5
  }
]

export function FeedbackRating({ onFeedbackEmojiSelection, emojiSelected }) {
  const [hoveredEmoji, setHoveredEmoji] = React.useState(null)

  function toggleHover(feedbackEmojiName) {
    setHoveredEmoji(prev => (prev ? null : feedbackEmojiName))
  }

  return (
    <Root layout='horizontal' align='center' justify='center' gap={16}>
      {feedbackEmojis.map(feedbackEmoji => (
        <FeedbackEmojiContainer
          key={feedbackEmoji.name}
          align='center'
          gap={6}
          onClick={_ =>
            onFeedbackEmojiSelection(feedbackEmoji.name, feedbackEmoji.rating)
          }
        >
          <FeedbackEmoji
            currentlyHovered={hoveredEmoji || emojiSelected}
            isHovered={
              feedbackEmoji.name === hoveredEmoji ||
              emojiSelected === feedbackEmoji.name
            }
            onMouseEnter={_ => toggleHover(feedbackEmoji.name)}
            onMouseLeave={_ => toggleHover(feedbackEmoji.name)}
          >
            {feedbackEmoji.svg}
          </FeedbackEmoji>
          <Text fontWeight={500} fontSize={12}>
            {feedbackEmoji.name}
          </Text>
        </FeedbackEmojiContainer>
      ))}
    </Root>
  )
}

const Root = styled(Block)``
const FeedbackEmojiContainer = styled(Block)`
  cursor: pointer;
`
const FeedbackEmoji = styled.div`
  ${({ isHovered, currentlyHovered }) =>
    !isHovered &&
    currentlyHovered &&
    css`
      opacity: 0.3;
    `};
`
